import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import lockSvg from '../../imgs/lock.svg';

class ShowCase extends PureComponent {
  constructor() {
    super();
    this.state = {
      isHover: false
    };
    this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this);
    this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this);
  }

  onMouseEnterHandler() {
    this.setState({
      isHover: true
    });
  }
  onMouseLeaveHandler() {
    this.setState({
      isHover: false
    });
  }

  render() {
    const { isHover } = this.state;
    const {
      title,
      name,
      summary,
      types,
      date,
      href,
      isConfidential,
      preImg
    } = this.props;
    return (
      <section className="case row show-case">
        <div className="description three columns">
          <div className="client">
            <div className="client-title">
              <h3>{title}</h3>
              <hr className="vLine" />
            </div>
            <h1>{name}</h1>
          </div>
          <p className="summary">{summary}</p>
          <h3>
            {types.map(type => (
              <span key={type}>{type}</span>
            ))}
          </h3>
          <h3 className="date">{date}</h3>
          <a className="caseStudy demo-link" href={href}>
            {isConfidential ? 'Contact for case study →' : 'Case study →'}
          </a>
        </div>
        <div
          className="nine columns"
          onMouseEnter={this.onMouseEnterHandler}
          onMouseLeave={this.onMouseLeaveHandler}
        >
          <a className="toCase" href={href}>
            {isConfidential &&
              isHover && (
                <div className="preImg-contact-for-more">
                  <img src={lockSvg} alt="" />
                  <h2>Contact for case study</h2>
                </div>
              )}
            <img
              className={classNames('preImg', { noborder: isConfidential })}
              src={preImg}
              alt=""
            />
          </a>
        </div>
      </section>
    );
  }
}

ShowCase.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  types: PropTypes.arrayOf(PropTypes.string).isRequired,
  date: PropTypes.string.isRequired,
  preImg: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  isConfidential: PropTypes.bool
};

ShowCase.defaultProps = {
  isConfidential: false
};

export default ShowCase;



// WEBPACK FOOTER //
// ./src/Modules/Home/ShowCase.js